import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";

export default class ConditionReportRequestsModel extends BaseModel {
  uuid = null;
  inventory_uuid = null;
  first_name = null;
  last_name = null;
  email = null;
  message = null;
  status = 'draft';
  rejected_at = false;
  created_at = false;
  sent_at = false;

  activeTab = 0;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    inventory_uuid: 'required',
    title: 'required',
    body: 'required',
  };

  attributeLabels = {
    uuid: i18n.t('Sale'),
    inventory_uuid: i18n.t('Inventory'),
    message: i18n.t('Message'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    rejected_at: i18n.t('Rejected at'),
    rejected_by: i18n.t('Rejected by'),
    sent_at: i18n.t('Sent at'),
    sent_by: i18n.t('Sent by'),
    status: i18n.t('Status'),
    condition_report: i18n.t('Condition Report'),
  };

  attributeHints = {
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    this.initTranslatableFields(this);
  }

  isReleased(){
    return this.status === 'released'
  }

  isDraft() {
    return this.status === 'draft'
  }
}

defineTranslatableProperties(ConditionReportRequestsModel);
